import CXMApiClient from "../CXMApiClient";
import Vue from "vue";
import {
  TouchpointType,
  Product,
  ProductStatus,
  AccountProductFeature
} from "@/lib/utilities/enums";

function initialState() {
  return {
    touchpointSettings: [],
    loadedTouchpointSettings: false,
    reloadVisitData: false,
    StartTouchpointModal: {
      ShowModal: false,
      AccountPlatformId: null,
      ContactId: null,
      ContactName: null,
      TouchpointId: 0
    },
    ContactTouchpointStatus: {
      ContactId: null,
      ShowroomVisits: null,
      HasActiveShowroomVisit: false,
      DeliveryVisits: null,
      HasActiveDeliveryVisit: false
    },
    TouchpointMarkSoldModalInfo: {
      showModal: false,
      data: null,
      pageType: null
    }
  };
}

const state = initialState();

const getters = {
  reloadVisitData(state) {
    return state.reloadVisitData;
  },
  ShowroomStores(state) {
    if (!state.touchpointSettings || state.touchpointSettings.length == 0)
      return [];

    return state.touchpointSettings.filter(
      tp => tp.isEnabled && tp.touchpointId == TouchpointType.Showroom
    );
  },
  DeliveryStores(state) {
    if (!state.touchpointSettings || state.touchpointSettings.length == 0)
      return [];

    return state.touchpointSettings.filter(
      tp => tp.isEnabled && tp.touchpointId == TouchpointType.Delivery
    );
  },
  ShowroomEnabled(state, getters) {
    return getters.ShowroomStores && getters.ShowroomStores.length > 0;
  },
  DeliveryEnabled(state, getters) {
    return getters.DeliveryStores && getters.DeliveryStores.length > 0;
  }
};

const actions = {
  startVisit(context, request) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/api/contact_touchpoint/" + request.slug + "/start",
          request.body,
          request.scope ? [request.scope] : []
        )
        .then(resp => {
          if (resp.data && resp.data.successful) resolve(resp.data);
          else reject(data);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  async getTouchpointSummaries(context, request) {
    let client = new CXMApiClient();
    return await client
      .ProcessRequest(
        "post",
        "/api/touchpoint/activity/summary",
        request,
        request.accountPlatformIds
      )
      .catch(err => err.response);
  },
  getTouchpointSettings(context) {
    return new Promise((resolve, reject) => {
      let requestPayload = {
        accountPlatformIds: context.rootGetters.ExperienceManagerStores.map(
          store => store.AccountPlatformID
        )
      };
      if (
        !requestPayload.accountPlatformIds ||
        requestPayload.accountPlatformIds.length == 0
      )
        return [];
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/api/contact_touchpoint/settings/get",
          requestPayload
        )
        .then(resp => {
          if (resp.data && resp.data.successful) {
            context.commit("gotTouchpointSettings", resp.data.data);
            resolve(resp);
          } else reject(resp);
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },
  async endVisit(context, request) {
    let client = new CXMApiClient();
    let resp = await client
      .ProcessRequest(
        "POST",
        "/api/contact_touchpoint/" + request.slug + "/complete",
        request.body,
        request.scope ? [request.scope] : []
      )
      .catch(err => {
        return err.response;
      });
    return resp;
  },
  async cancelVisit(context, request) {
    let client = new CXMApiClient();
    let resp = await client
      .ProcessRequest(
        "POST",
        "/api/contact_touchpoint/" + request.slug + "/cancel",
        request.body,
        request.scope ? [request.scope] : []
      )
      .catch(err => {
        return err.response;
      });
    return resp;
  },
  async updateVisit(context, request) {
    let client = new CXMApiClient();
    let resp = await client
      .ProcessRequest(
        "PUT",
        "/api/contact_touchpoint/" + request.slug + "/update",
        request.body,
        request.scope ? [request.scope] : []
      )
      .catch(err => {
        return err.response;
      });
    return resp;
  },
  async cancelTouchpointStatus(context, request) {
    let client = new CXMApiClient();
    let resp = await client
      .ProcessRequest(
        "POST",
        `/api/contact_touchpoint/${request.touchpointSlug}/items/${request.touchpointItemSlug}/cancel`,
        { touchpointInstanceId: request.touchpointInstanceId }
      )
      .catch(err => {
        return err.response;
      });
    return resp && resp.data ? resp.data : null;
  },
  openStartTouchpointModal(context, data) {
    context.commit("openStartTouchpointModal", data);
  },
  closeStartTouchpointModal(context) {
    context.commit("closeStartTouchpointModal");
  },
  getContactTouchpointStatus(context, contactId) {
    context.commit("clearContactTouchpointStatus");
  },
  clearContactTouchpointStatus(context) {
    context.commit("clearContactTouchpointStatus");
  },
  updateTouchpointMarkSoldModalInfo(context, data) {
    context.commit("updateTouchpointMarkSoldModalInfo", data);
  },
  updateReloadVisitData(context, data) {
    context.commit("updateReloadVisitData", data);
  }
};

const mutations = {
  updateReloadVisitData(state, data) {
    state.reloadVisitData = data;
  },
  gotTouchpointSettings(state, data) {
    state.touchpointSettings = data && data.length > 0 ? data : [];
    state.loadedTouchpointSettings = true;
  },
  openStartTouchpointModal(state, data) {
    state.StartTouchpointModal.AccountPlatformId = data.AccountPlatformId;
    state.StartTouchpointModal.ContactId = data.ContactId;
    state.StartTouchpointModal.ContactName = data.ContactName;
    state.StartTouchpointModal.TouchpointId = data.TouchpointId;
    state.StartTouchpointModal.ShowModal = true;
  },
  closeStartTouchpointModal(state) {
    state.StartTouchpointModal.AccountPlatformId = null;
    state.StartTouchpointModal.ContactId = null;
    state.StartTouchpointModal.ContactName = null;
    state.StartTouchpointModal.TouchpointId = 0;
    state.StartTouchpointModal.ShowModal = false;
  },
  clearContactTouchpointStatus(state) {
    state.ContactTouchpointStatus.ContactId = null;
    state.ContactTouchpointStatus.ShowroomVisits = null;
    state.ContactTouchpointStatus.HasActiveDeliveryVisit = false;
    state.ContactTouchpointStatus.DeliveryVisits = null;
    state.ContactTouchpointStatus.HasActiveDeliveryVisit = false;
  },
  updateTouchpointMarkSoldModalInfo(state, data) {
    state.TouchpointMarkSoldModalInfo = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/Touchpoint.js